import {
  IVisaSearchCountry,
  IVisaSearchParams,
  IVisaSearchQueryArgs,
  IVisaSearchSchema,
  IVisaTypeOption,
} from "@/feature/visa/search/types/visa.types";

export function encodedVisaParams(data: IVisaSearchSchema): string {
  const params = new URLSearchParams();

  if (data.country?.name) {
    params.set("country", encodeURIComponent(JSON.stringify(data.country)));
  }

  if (data.visa_type?.name) {
    params.set("visa_type", encodeURIComponent(JSON.stringify(data.visa_type)));
  }

  if (Number.isFinite(data.travelers)) {
    params.set("travelers", String(data.travelers));
  }

  return params.toString();
}

function parseTravelers(value?: string) {
  const travelers = Number(value);
  if (!Number.isFinite(travelers)) {
    return 1;
  }

  const normalized = Math.floor(travelers);
  return Math.min(20, Math.max(1, normalized));
}

function parseEncodedObject<T>(value?: string): T | null {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(decodeURIComponent(value)) as T;
  } catch {
    return null;
  }
}

function normalizeCountry(country: IVisaSearchCountry | null): IVisaSearchCountry | null {
  if (!country?.name) {
    return null;
  }

  return {
    id: country.id,
    name: country.name,
    iso: country.iso,
    iso3: country.iso3,
    phone_code: country.phone_code,
  };
}

function normalizeVisaType(visaType: IVisaTypeOption | null): IVisaTypeOption | null {
  if (!visaType?.name) {
    return null;
  }

  return {
    id: visaType.id,
    name: visaType.name,
  };
}

export function decodedVisaParams(
  params: IVisaSearchParams,
): IVisaSearchSchema {
  const country = normalizeCountry(
    parseEncodedObject<IVisaSearchCountry>(params.country),
  );
  const visaType = normalizeVisaType(
    parseEncodedObject<IVisaTypeOption>(params.visa_type),
  );

  return {
    country,
    visa_type: visaType,
    travelers: parseTravelers(params.travelers),
  };
}

export function toVisaSearchQueryArgs(
  data: IVisaSearchSchema,
): IVisaSearchQueryArgs {
  return {
    country_id:
      data.country?.id !== undefined ? String(data.country.id) : undefined,
    visa_type_id:
      data.visa_type?.id !== undefined ? String(data.visa_type.id) : undefined,
  };
}
